export const investTypes =  [
    {
      name: "课程联营",
      value: 1,
    },
    {
      name: "场地联营",
      value: 2,
    }
  ]



  export const mechanismUnionType =  [
    {
      name: "驻店教练",
      value: 'c_store',
    },
    {
      name: "类目主理教练",
      value: 'c_category',
    },{
      name: "合伙教练",
      value: 'c_owner',
    },
    {
      name: "运营主理人",
      value: 'o_manager',
    },+
    {
      name: "运营合伙人",
      value: 'o_owner',
    }
  ]




  
  export const unionRatioTypeList =  [
    {
      name: "订场",
      value: 'appo',
    },
    {
      name: "助教",
      value: 'exper',
    },
    {
      name: "商品",
      value: 'goods',
    },
  ]


 